import React from 'react';
import {Datagrid, TextField, NumberField, DateField} from 'react-admin';
import {DefaultList} from 'utils/defaultList/DefaultList';
import {useTranslation} from 'react-i18next';

export const WalletList = (props: unknown): React.ReactElement => {
    const {t} = useTranslation();

    return <DefaultList {...props}>
        <Datagrid>
            <TextField source="id" />
            <NumberField source="customer_id" />
            <NumberField source="system_id" />
            <TextField source="account" />
            <NumberField source="bank_id" />
            <NumberField source="total_cashout" />
            <NumberField source="total_deposit" />
            <DateField source="created_at" label={t('date')}/>
        </Datagrid>
    </DefaultList>;
};

